/* tslint:disable:max-line-length */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/dashboard",
  },
  {
    id: "membership",
    title: "Membership",
    type: "basic",
    icon: "heroicons_outline:ticket",
    link: "/all-membership",
  },
  {
    id: "registered-programs",
    title: "Registered Programs",
    type: "basic",
    icon: "heroicons_outline:calendar",
    link: "/registered-programs",
  },
  {
    id: "profile",
    title: "My Profile",
    type: "basic",
    icon: "heroicons_outline:user-circle",
    link: "/manage-profile",
  },
  {
    id: "programs",
    title: "Explore Programs",
    type: "basic",
    icon: "heroicons_outline:book-open",
    externalLink: true,
    target: "_blank",
  },

  {
    id: "privacy",
    title: "Privacy Policy",
    type: "basic",
    icon: "heroicons_outline:key",
    externalLink: true,
    target: "_blank",
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/dashboard",
  },
  {
    id: "profile",
    title: "Manage Profile",
    type: "basic",
    icon: "heroicons_outline:user",
    link: "/manage-profile",
  },
  {
    id: "membership",
    title: "Membership",
    type: "basic",
    icon: "heroicons_outline:ticket",
    link: "/membership-detail",
  },
  {
    id: "registered-programs",
    title: "Programs",
    type: "basic",
    icon: "heroicons_outline:calendar",
    link: "/registered-programs",
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/dashboard",
  },
  {
    id: "profile",
    title: "Manage Profile",
    type: "basic",
    icon: "heroicons_outline:user",
    link: "/manage-profile",
  },
  {
    id: "membership",
    title: "Membership",
    type: "basic",
    icon: "heroicons_outline:ticket",
    link: "/membership-detail",
  },
  {
    id: "registered-programs",
    title: "Programs",
    type: "basic",
    icon: "heroicons_outline:calendar",
    link: "/registered-programs",
  },
];

export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:view-grid",
    link: "/dashboard",
  },
  {
    id: "profile",
    title: "Manage Profile",
    type: "basic",
    icon: "heroicons_outline:user",
    link: "/manage-profile",
  },
  {
    id: "membership",
    title: "Membership",
    type: "basic",
    icon: "heroicons_outline:ticket",
    link: "/membership-detail",
  },
  {
    id: "registered-programs",
    title: "Programs",
    type: "basic",
    icon: "heroicons_outline:calendar",
    link: "/registered-programs",
  },
];
